// extracted by mini-css-extract-plugin
export default {"EmptyState":"QualityList_EmptyState__S5359"};